import { render, staticRenderFns } from "./instruction.vue?vue&type=template&id=167f3a67&scoped=true&"
import script from "./instruction.vue?vue&type=script&lang=js&"
export * from "./instruction.vue?vue&type=script&lang=js&"
import style0 from "./instruction.vue?vue&type=style&index=0&id=167f3a67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167f3a67",
  null
  
)

export default component.exports